import { EDRIntegration } from '@investigator/features/integrations/pages/IntegrationsConstants';

/** Layout options for entity information display */
export enum EntityFieldLayout {
  FullWidth = 'fullWidth',
  HalfWidth = 'halfWidth',
}

/** Available entity field labels */
export enum EntityFieldLabel {
  HostName = 'Host Name',
  MachineOS = 'Machine OS',
  Locality = 'Locality',
  Origin = 'Origin',
  ASN = 'ASN',
  DHCP = 'DHCP',
  ServicePortProto = 'Service Port/Proto',
  ClientProtocols = 'Client Protocols',
  Users = 'Users',
  ServerSoftware = 'Server Software',
  ServiceName = 'Service Name',
  CertificateSubject = 'Certificate Subject',
  HostVLAN = 'Host VLAN',
}

/** Value with its EDR source for icon display */
export interface EdrHost {
  value: string;
  source: EDRIntegration;
}

/** Location data for displaying origin with country flag */
export interface LocationData {
  countryCode?: string;
  country?: string;
  city?: string;
}

/** Entity information field with all display properties */
export interface EntityInformationField {
  label: EntityFieldLabel;
  value: string | undefined;
  /** For fields that can have multiple values (e.g., Host Name, Users) */
  values?: string[];
  /** For fields with values that need EDR source icons */
  edrHosts?: EdrHost[];
  hasOsIcon?: boolean;
  /** Location data for Origin field with flag */
  locationData?: LocationData;
  /** Loading state for progressive skeleton loading */
  isLoading?: boolean;
}
